import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setClassNames } from '@ddc/classnames-js';
import { useRequestData, useLabels } from 'wsm-common-data';
import { FetchReviewsContext } from '../providers/FetchReviewsProvider';
import { toTitleCase } from '../utils';
import { updateTypeFilters } from '../actions/reviewsFilters';

const TypeFilters = () => {
	// hooks
	const { deviceType } = useRequestData();
	const labels = useLabels();
	/**
	 * @type {TypesState}
	 */
	const typesFilters = useSelector((state) => state.reviewsFilters.types);
	const { isLoading, fetchReviews } = useContext(FetchReviewsContext);
	const dispatch = useDispatch();
	// variables
	const isDesktop = deviceType === 'DESKTOP';
	// handlers
	const handleTypeFilterChange = (event) => {
		dispatch(updateTypeFilters(event.target.value));
		const queries = {
			types: {
				selected: event.target.value
			}
		};
		fetchReviews(1, queries);
	};
	// classes
	const fieldsetClasses = [
		'type-filters',
		'filters',
		isDesktop ? '' : 'flex-row'
	];
	const legendClasses = ['type-filters__legend', 'font-weight-bold'];
	const typeFilterClasses = ['filter'];
	const labelClasses = ['type-filters__label'];

	return (
		<fieldset className={setClassNames(fieldsetClasses)}>
			<legend className={setClassNames(legendClasses)}>
				{labels.getHTML('VW_REVIEWS_FILTER_SURVEY_TYPE')}
			</legend>
			{typesFilters.options.map((value) => {
				const id = `type-filter__radio-${value}`;
				return (
					<div key={id} className={setClassNames(typeFilterClasses)}>
						<label
							htmlFor={id}
							className={setClassNames(labelClasses)}
						>
							<input
								type="radio"
								id={id}
								checked={value === typesFilters.selected}
								value={value}
								disabled={isLoading}
								onChange={handleTypeFilterChange}
								name="filter-types"
							/>
							{toTitleCase(value)}
						</label>
					</div>
				);
			})}
		</fieldset>
	);
};

export default TypeFilters;
